export const intervalTypes = Object.freeze({
  month: 'month',
  year: 'year',
});

export type Interval = typeof intervalTypes[keyof typeof intervalTypes];

export const flagTypes = Object.freeze({
  australia: 'Australia',
  brazil: 'Brazil',
  canada: 'Canada',
  europeanUnion: 'EuropeanUnion',
  greatBritain: 'GreatBritain',
  india: 'India',
  japan: 'Japan',
  newZealand: 'NewZealand',
  unitedStates: 'UnitedStates',
});

export type Flag = typeof flagTypes[keyof typeof flagTypes];

export type Currency = {
  icon?: Flag;
  multiplier: number;
  name: string;
  symbol: string;
};

export type InvoiceLineItem = {
  amount: number;
  description?: string;
  id: string;
};

export type InvoiceLineSubscription = {
  amount: number;
  id: string;
  plan?: {
    interval: Interval;
    name: string;
  };
};

export const trialExtensionReasons: {
  [x: string]: string;
} = {
  paths: 'paths',
  multistep: 'multistep',
  premium: 'premium',
  premiumLimit: 'premium-limit',
  zapLimit: 'live-zaps',
  taskLimit: 'tasks',
  emailSupport: 'email-support',
  unknown: 'unknown',
};

export type TrialExtensionReason = keyof typeof trialExtensionReasons;
